<script>
export default { name: 'UiButton' };
</script>

<script setup>
import { computed } from 'vue';
import { Loader2 } from 'lucide-vue-next';

const props = defineProps({
  // primary | secondary | ghost | soft | danger | success
  variant: { type: String, default: 'primary' },
  // sm | md | lg
  size: { type: String, default: 'md' },
  // button | submit | reset
  type: { type: String, default: 'button' },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  // Botón solo-ícono (padding cuadrado, ej. botones de acción en tablas).
  iconOnly: { type: Boolean, default: false },
  fullWidth: { type: Boolean, default: false },
});

const BASE =
  'inline-flex items-center justify-center gap-2 font-bold rounded-xl transition-all outline-none cursor-pointer select-none disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none';

const VARIANTS = {
  primary:
    'bg-brand-600 hover:bg-brand-700 active:bg-brand-800 text-white shadow-lg shadow-brand-500/30 focus-visible:ring-4 focus-visible:ring-brand-500/30',
  secondary:
    'bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 focus-visible:ring-4 focus-visible:ring-slate-400/30',
  ghost:
    'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 focus-visible:ring-4 focus-visible:ring-slate-400/30',
  soft: 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30 focus-visible:ring-4 focus-visible:ring-red-500/30',
  danger:
    'bg-red-500 hover:bg-red-600 active:bg-red-700 text-white shadow-lg shadow-red-500/20 focus-visible:ring-4 focus-visible:ring-red-500/30',
  success:
    'bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg shadow-emerald-500/30 focus-visible:ring-4 focus-visible:ring-emerald-500/30',
};

const SIZES = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-sm',
};

const classes = computed(() => [
  BASE,
  VARIANTS[props.variant] || VARIANTS.primary,
  props.iconOnly ? 'p-2.5' : SIZES[props.size] || SIZES.md,
  props.fullWidth ? 'w-full' : '',
]);
</script>

<template>
  <button :type="type" :disabled="disabled || loading" :class="classes" v-bind="$attrs">
    <Loader2 v-if="loading" class="w-4 h-4 animate-spin" aria-hidden="true" />
    <slot />
  </button>
</template>